import React from "react";
import Header from "../../../Components/comman/Header";
import SideMenu from "../SideMenu";
import { Tab } from "react-bootstrap";
import { Link } from "react-router-dom";
import Images from "../../../Helpers/Images";
import MobileHeader from "../../../Components/comman/MobileHeader";

const BrandInbox = () => {
  return (
    <div className="brand-dashboard-wrapper">
      <Header />
      <MobileHeader />
      <div className="brand-dashboard-inner ">
        <Tab.Container activeKey={`inbox`}>
          <SideMenu />
          <div className="brand-dashboard-content-wrapper">
            <Tab.Content>
              <Tab.Pane eventKey={"inbox"}>
                <div className="inbox-wrapper">
                  <div className="content-area">
                    <img src={Images.noAccount} alt="no acoount" />
                    <p>You have no messages.</p>
                    <Link to="/brand/campaigns" className="theme-btn">
                      Back To Campaigns
                    </Link>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </div>
    </div>
  );
};

export default BrandInbox;
